// extracted by mini-css-extract-plugin
module.exports = {"introText":"IntroText_introText__Teucr","introTextBottomPadding":"IntroText_introTextBottomPadding__cViEc"};